<button
  (click)="onClick($event)"
  [attr.tabindex]="removeFromNavigation ? '-1' : undefined"
  [class.btn-primary-blue]="theme === ButtonTheme.PRIMARY_BLUE"
  [class.btn-primary-heather]="theme === ButtonTheme.PRIMARY_HEATHER"
  [class.btn-secondary]="theme === ButtonTheme.SECONDARY"
  [class.btn-tertiary]="theme === ButtonTheme.TERTIARY"
  [class.btn-tertiary-white]="theme === ButtonTheme.TERTIARY_WHITE"
  [class.btn-secondary-white]="theme === ButtonTheme.SECONDARY_WHITE"
  [class.btn-am-orange]="theme === ButtonTheme.AM_ORANGE"
  [class.btn-loading]="loading"
  [class.btn-fully-rounded]="isCircle"
  [class.has-text]="text"
  [class.btn-disabled]="appearDisabled"
  [class.btn-fill]="mode === ButtonMode.FILL"
  [class.btn-fill-mobile]="mode === ButtonMode.FILL_MOBILE"
  [ngClass]="{
    'ps-medium-x':
      !!text &&
      (size === ButtonSize.R_SMALL ||
        size === ButtonSize.R_MEDIUM ||
        size === ButtonSize.S_SMALL ||
        size === ButtonSize.S_MEDIUM ||
        size === ButtonSize.R_LARGE ||
        size === ButtonSize.S_LARGE),
    'ps-large-x': !!text && (size === ButtonSize.R_XLARGE || size === ButtonSize.S_XLARGE),
    'font-heading-4': size === ButtonSize.S_XLARGE || size === ButtonSize.R_XLARGE,
    'font-body-1':
      size === ButtonSize.R_SMALL ||
      size === ButtonSize.R_MEDIUM ||
      size === ButtonSize.R_LARGE ||
      size === ButtonSize.S_LARGE ||
      size === ButtonSize.S_SMALL ||
      size === ButtonSize.S_MEDIUM
  }"
  [disabled]="disabled || (loading && !appearDisabled)"
  [type]="type"
  [attr.title]="title"
  [attr.aria-label]="currentLoadingLabel"
  [attr.aria-describedby]="aria && aria.describedby"
  [attr.role]="aria.role || 'button'"
  [attr.aria-disabled]="aria && aria.disabled"
  class="rounded bold-type block"
  (blur)="blur.next()"
  #buttonElement
>
  <!-- Button cannot be flex container on certain browsers, https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers -->
  <span
    class="flex"
    [ngClass]="{
      'ip-small': !text && size === ButtonSize.R_SMALL,
      'ip-medium': !text && size === ButtonSize.R_MEDIUM,
      'ip-large': !text && size === ButtonSize.R_LARGE,
      'ip-xlarge': !text && size === ButtonSize.R_XLARGE,
      'ips-small': !text && size === ButtonSize.S_SMALL,
      'ips-medium': !text && size === ButtonSize.S_MEDIUM,
      'ips-large': !text && size === ButtonSize.S_LARGE,
      'ips-xlarge': !text && size === ButtonSize.S_XLARGE
    }"
  >
    <ng-container
      *ngTemplateOutlet="
        iconTemplate;
        context: {
          show: icon && icon.position === IconPosition.LEFT,
          icon: icon,
          loading: loading,
          size: size,
          text: text
        }
      "
    ></ng-container>
    <span
      *ngIf="text"
      class="text flex-1 flex--self-center"
      [ngClass]="{
        'ps-xxsmall-y': size === ButtonSize.R_SMALL || size === ButtonSize.S_SMALL,
        'ps-xsmall-y': size === ButtonSize.R_MEDIUM || size === ButtonSize.S_MEDIUM,
        'ps-small-y':
          size === ButtonSize.R_LARGE ||
          size === ButtonSize.S_LARGE ||
          size === ButtonSize.R_XLARGE ||
          size === ButtonSize.S_XLARGE
      }"
    >
      <span [ngClass]="{ 'hide-element': loading }" [attr.aria-hidden]="loading">{{ text }}</span>
      <fcom-loader *ngIf="loading" class="absolute flex center-icon" [loaderType]="LoaderTheme.BUTTON"></fcom-loader>
    </span>
    <ng-container
      *ngTemplateOutlet="
        iconTemplate;
        context: {
          show: icon && icon.position === IconPosition.RIGHT,
          icon: icon,
          loading: loading,
          size: size,
          text: text
        }
      "
    ></ng-container>
  </span>
</button>

<ng-template #iconTemplate let-show="show" let-icon="icon" let-loading="loading" let-size="size" let-text="text">
  <fcom-icon
    *ngIf="show"
    class="flex--nogrow flex--self-center"
    [category]="loading ? 'svg-library' : icon.category"
    [name]="loading ? 'transfer-loader' : icon.name"
    [class.ms-xxsmall-l]="text && icon.position === IconPosition.RIGHT"
    [class.ms-xxsmall-r]="text && icon.position === IconPosition.LEFT"
    [ngClass]="{
      'icon-medium':
        size === ButtonSize.S_SMALL ||
        size === ButtonSize.S_MEDIUM ||
        size === ButtonSize.S_LARGE ||
        size === ButtonSize.R_MEDIUM ||
        size === ButtonSize.R_LARGE ||
        size === ButtonSize.R_XLARGE,
      'icon-large': size === ButtonSize.S_XLARGE,
      'icon-small': size === ButtonSize.R_SMALL,
      'hide-element': loading && text
    }"
  >
  </fcom-icon>
</ng-template>
